import { useParams, Link } from "react-router-dom";
import { animeList } from "@/mocks/animeData";
import { categories } from "@/mocks/categories";
import AnimeCard from "@/components/feature/AnimeCard";
import Breadcrumb from "@/components/feature/Breadcrumb";
import CategoryTabs from "@/components/feature/CategoryTabs";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredAnime = animeList.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <span className="w-16 h-16 flex items-center justify-center mx-auto text-foreground-500">
            <i className="ri-error-warning-line text-4xl"></i>
          </span>
          <h2 className="text-xl font-bold text-foreground-200 mt-4">
            分类未找到
          </h2>
          <Link
            to="/"
            className="inline-block mt-4 text-sm text-primary-400 hover:text-primary-300 cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <main className="min-h-screen pt-20 pb-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto w-full">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: "分类浏览", href: "/category/action" },
            { label: category.name },
          ]}
        />

        <div className="mb-10">
          <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 mb-2">
            {category.name}
          </h1>
          <p className="text-sm text-foreground-500">{category.description}</p>
        </div>

        <div className="mb-8">
          <CategoryTabs />
        </div>

        {filteredAnime.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
            {filteredAnime.map((anime, index) => (
              <div
                key={anime.id}
                className={`animate-fade-in-up ${
                  index > 0 ? `animation-delay-${Math.min(index, 5) * 100}` : ""
                }`}
              >
                <AnimeCard anime={anime} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <span className="w-16 h-16 flex items-center justify-center mx-auto text-foreground-600">
              <i className="ri-emotion-sad-line text-4xl"></i>
            </span>
            <p className="text-foreground-500 mt-4">
              该分类暂无动漫作品，敬请期待
            </p>
          </div>
        )}
      </div>
    </main>
  );
}